import { motion } from 'motion/react';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block bg-accent-100 text-accent-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
            Since 2010
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            About Our Shop
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            A trusted name in Tumkur for over 15 years — connecting people to the technology and appliances they need.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="relative rounded-xl overflow-hidden border border-background-200/70 group"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/edited_c7e9c9aa027034e7b4b3bf331acb2c36_4d9c823a.jpg"
              alt="Ashok Communication Interior - Phone Collection"
              className="w-full h-72 md:h-96 object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-4 md:p-6">
              <p className="text-background-50 font-semibold text-sm md:text-base">
                Our phone collection — real stock, real brands
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="space-y-5 md:space-y-6"
          >
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
                Your Local Partner for Everything Electronics
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                Ashok Communication started in 2010 as a small mobile recharge shop in Tumkur, Karnataka. Over the years, we grew into a full-service electronics and telecom destination — selling the latest smartphones, home appliances, Smart TVs, and offering services like DTH installation, mobile repairs, and money transfer.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl mb-3">
                  <i className="ri-store-2-line text-primary-600 text-lg"></i>
                </div>
                <p className="font-semibold text-foreground-950 text-sm mb-1">Local Store</p>
                <p className="text-foreground-500 text-xs">Walk in and browse real stock</p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-xl mb-3">
                  <i className="ri-tools-line text-accent-600 text-lg"></i>
                </div>
                <p className="font-semibold text-foreground-950 text-sm mb-1">In-House Service</p>
                <p className="text-foreground-500 text-xs">Repairs done right at our shop</p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-xl mb-3">
                  <i className="ri-hand-heart-line text-secondary-600 text-lg"></i>
                </div>
                <p className="font-semibold text-foreground-950 text-sm mb-1">Trusted Brands</p>
                <p className="text-foreground-500 text-xs">Only genuine products and parts</p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl mb-3">
                  <i className="ri-customer-service-2-line text-primary-600 text-lg"></i>
                </div>
                <p className="font-semibold text-foreground-950 text-sm mb-1">After-Sales Support</p>
                <p className="text-foreground-500 text-xs">We stand behind every sale</p>
              </div>
            </div>

            <div className="flex items-center gap-4 pt-2">
              <a
                href="#contact"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </span>
                Visit Us
              </a>
              <a
                href="tel:+919964111963"
                className="border-2 border-background-200/70 hover:border-primary-300 text-foreground-700 hover:text-primary-600 px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                Call Now
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}